module.exports = __webpack_public_path__ + "static/media/no-image.ec45b213.svg";